export enum Brand {
  DEFAULT = 'default',
  FERTILLY_COM = 'fertilly',
  KLINIK_AM_SCHLOSSPARK_DE = 'klinik',
}

export const getBrand = (): Brand => {
  const hostname = window.location.hostname;

  if (hostname.includes('login.kinderwunsch-am-schlossplatz.de') || hostname.includes('klinik-am-schlosspark.staging.leancoders.de')) {
    return Brand.KLINIK_AM_SCHLOSSPARK_DE;
  }
  else if (hostname.includes('fertilly.com') || hostname.includes('fertilly.staging.leancoders.de')) {
    return Brand.FERTILLY_COM;
  }

  return Brand.DEFAULT;
};
